var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4426 0.538209L19.4426 0.538225L19.4461 0.535479C19.4515 0.531292 19.4699 0.521036 19.5 0.514526V17.9002C19.498 17.9908 19.4499 18.1127 19.2992 18.2247L19.2989 18.2249L14.9043 21.4962V4.04547C14.9077 4.04067 14.915 4.03207 14.9286 4.02136L14.9286 4.02137L14.9304 4.01998L16.244 2.97947L19.4426 0.538209Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89483 18.2247L4.8947 18.2248L0.5 21.4948V4.0448C0.503332 4.03993 0.510613 4.03091 0.524658 4.01968C0.524779 4.01959 0.524901 4.01949 0.525024 4.01939L1.83965 2.97953L5.03662 0.538127L5.03694 0.53788C5.04486 0.53182 5.06492 0.521114 5.09569 0.514517V15.9016V17.8974C5.09569 17.985 5.04907 18.1101 4.89483 18.2247Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84573 18.2249L7.84551 18.2247C7.69127 18.1101 7.64465 17.985 7.64465 17.8974V15.9016V0.514526C7.67479 0.521036 7.6931 0.531292 7.69849 0.535479L7.69848 0.535495L7.70203 0.538209L10.9006 2.97946L12.2143 4.01998L12.2143 4.01998L12.216 4.02136C12.2297 4.03207 12.2369 4.04067 12.2403 4.04547V21.4962L7.84573 18.2249Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStay);
export default __webpack_public_path__ + "static/media/stay.a9e7737ccf84c49b98f33ee841cbe54d.svg";
export { ForwardRef as ReactComponent };